import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNumber, IsOptional } from 'class-validator';
import { StoreItemsExposeGroup } from '../enum';
import { ReadAbstractModsDto } from './ReadAbstractModsDto';
export class ReadStoreItemGroupModsDto extends ReadAbstractModsDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 9.99 }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], ReadStoreItemGroupModsDto.prototype, "price", void 0);
//# sourceMappingURL=ReadStoreItemGroupModsDto.js.map